import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="m12 22.5c-5.775 0-10.5-4.725-10.5-10.5s4.725-10.5 10.5-10.5 10.5 4.725 10.5 10.5-4.725 10.5-10.5 10.5zm0-19.5c-4.95 0-9 4.05-9 9s4.05 9 9 9 9-4.05 9-9-4.05-9-9-9z"
      fill="currentColor"
      strokeWidth=".375"
    />
    <path
      d="m8.8125 18c-0.1125 0-0.2625-0.0375-0.375-0.1125-0.225-0.15-0.375-0.375-0.375-0.6375v-10.5c0-0.2625 0.15-0.525 0.375-0.6375 0.225-0.15 0.525-0.15 0.75 0l9 5.25c0.225 0.15 0.375 0.375 0.375 0.6375s-0.15 0.525-0.375 0.6375l-9 5.25c-0.1125 0.075-0.2625 0.1125-0.375 0.1125zm0.75-9.9375v7.875l6.75-3.9375z"
      fill="currentColor"
      strokeWidth=".375"
    />
  </>
);

const Icon = createSvgIcon(svg, 'PlaySecondary');

export default Icon;
